import { compose } from 'redux';

import { routes } from 'config';

import { NavigationElement } from 'modules/shared/models';

import { readCMSValue, getDefault, readPageTitle } from 'modules/shared-cms/utils';
import { WithFetchDatasByIdFromCMS, WithCMSSEO } from 'modules/shared-cms/hocs';
import { WithFetchDatasByParamsFromCMS } from 'modules/shared-cms-advanced/hocs';

import { createPath, createPathId, concatUrl } from 'modules/shared/utils';
import { WithNotifyRessourceLoaded, WithNotifyRessourceLoadedInputProps } from 'modules/shared/hocs';
import { WithFetchDatasByIdFromCMSInputProps } from 'modules/shared-cms/hocs/with-fetch-datas-by-id-from-cms';

import { QUERY, BRAND_QUERY } from './dress-query';
import { DressLoader } from './dress-loader';

const getAdditionalParentTree = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props?: any,
    parentNavigationTree?: NavigationElement,
): NavigationElement | undefined => {
    if (props && props.queryCornerMarqueContents && props.queryCornerMarqueContents.length > 0) {
        const parentPageName = getDefault(readCMSValue(props.queryCornerMarqueContents[0].data.pageTitle), '');
        const parentPageId = getDefault(readCMSValue(props.queryCornerMarqueContents[0].data.brandId), '');

        return {
            name: parentPageName,
            path: concatUrl([routes.laRobe.createurs, createPathId(createPath(parentPageName), `${parentPageId}`)]),
            parent: parentNavigationTree,
        };
    }

    return undefined;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getParams = (props?: any): { key: string; value: string }[] => {
    if (!props) {
        return [];
    }
    return [{ key: 'brandId', value: `${getDefault(readCMSValue(props.brandId), '')}` }];
};

const enhancer = compose<
    React.ComponentType<WithFetchDatasByIdFromCMSInputProps & WithNotifyRessourceLoadedInputProps>
>(
    WithFetchDatasByIdFromCMS(QUERY, DressLoader, 'findFicheProduitRobeContent'),
    WithFetchDatasByParamsFromCMS(
        DressLoader,
        BRAND_QUERY,
        undefined,
        [{ filter: "data/brandId/iv eq $brandId and data/typeMarque/iv eq 'robes'" }],
        undefined,
        false,
        getParams,
    ),
    WithNotifyRessourceLoaded(readPageTitle, getAdditionalParentTree),
    WithCMSSEO(),
);

export default enhancer;
